import { AITrainingMaterialFragment } from 'types/graphql'

import { EllipsisButton } from 'src/components/EllipsisButton'
import { ActionItem } from 'src/govwell-ui/types'
import useDisclosure from 'src/hooks/use-disclosure'
import { RefetchFnType } from 'src/types'

import DeleteAITrainingMaterialModal from './DeleteAITrainingMaterialModal'

interface Props {
  material: AITrainingMaterialFragment
  refetch: RefetchFnType
}

const AITrainingMaterialsTableButtons = ({ material, refetch }: Props) => {
  const deleteModal = useDisclosure()
  const items: ActionItem[] = [
    {
      label: 'Delete',
      icon: 'FaTrash',
      onClick: deleteModal.open,
      key: 'delete',
    },
  ]
  return (
    <>
      <EllipsisButton items={items} />
      {deleteModal.isOpen && (
        <DeleteAITrainingMaterialModal
          modalState={deleteModal}
          id={material.id}
          refetch={refetch}
        />
      )}
    </>
  )
}

export default AITrainingMaterialsTableButtons
